// extracted by mini-css-extract-plugin
module.exports = {"SubTitulo":"styles_SubTitulo__2il0z"};